import "./App.css";
import Error from "./components/Error";
import Home from "./components/Home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import EventList from "./components/Events/EventList";
import Master from "./components/master";
import EventDetails from "./components/Events/EventDetails";
import LoginWithPhoneNumber from "./components/auth/LoginPage";
import AuthGuard from "./utils/route-guard/AuthGuard";
import LoginWithEmail from "./components/auth/LoginwithEmail";
import { additional_url, GOOGLE_CLIENT_ID } from "./config/url";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import EventReviews from "./components/Events/EventReviews";
import EventCategory from "./components/Events/EventCategory";
import EventUserDetails from "./components/Events/EventUserDetails";
import PaymentDetails from "./components/Payment/PaymentDetails";
import TicketDetails from "./components/Payment/TicketDetails";
import Dashboard from "./components/Dashboard";
import Booking from "./components/Booking";
import Wishlist from "./components/Wishlist";
import Review from "./components/Review";
import Polls from "./components/Polls";
import Profile from "./components/Profile";
import Support from "./components/Support";
import { ToasterProvider } from "./context/ToasterContext";
import SignupSuccess from "./components/SignupSuccess";
import ViewTickets from "./components/ViewTickets";
import TermAndCondition from "./components/TermAndCondition";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CancellationPolicy from "./components/CancellationPolicy";
import GuestGuard from "./utils/route-guard/GuestCuard";
import CategoryBlog from "./components/homecomponents/CategoryBlog";
import AllBlog from "./components/homecomponents/AllBlog";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import EventResult from "./components/Events/EventResult";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  // You can add other theme customizations here
});
const appLayout = createBrowserRouter([
  {
    path: `${additional_url}`,
    element: (
      // <AuthGuard>
      <Master />
      // </AuthGuard>
    ),
    children: [
      {
        path: "login",
        element: (
          <GuestGuard>
            <LoginWithPhoneNumber />
          </GuestGuard>
        ),
      },
      {
        path: "login-with-email",
        element: (
          // <GuestGuard>
          <LoginWithEmail />
          // </GuestGuard>
        ),
      },
      {
        path: "signup-success",
        element: (
          <GuestGuard>
            <SignupSuccess />
          </GuestGuard>
        ),
      },
      {
        path: "forgot-password",
        element: <></>, // Or provide a component for this path
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "results",
        element: <EventResult />,
      },
      {
        path: "event/list",
        element: <EventList />,
      },
      {
        path: "event-details/:event_name/:event_id",
        element: <EventDetails />,
      },
      {
        path: "event-reviews/:event_id",
        element: <EventReviews />,
      },
      {
        path: "blog/:blog_id",
        element: <CategoryBlog />,
      },
      {
        path: "blogs",
        element: <AllBlog />,
      },
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
      {
        path: "event-category/:event_id",
        element: <EventCategory />,
      },
      {
        path: "event-user-details/:event_id",
        element: <EventUserDetails />,
      },
      {
        path: "payment-details",
        element: <PaymentDetails />,
      },
      {
        path: "ticket-details",
        element: <TicketDetails />,
      },
      {
        path: "view-ticket/:booking_id",
        element: <ViewTickets />,
      },
      {
        path: "term-condition",
        element: <TermAndCondition />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "cancellation-policy",
        element: <CancellationPolicy />,
      },
      {
        path: "dashboard",
        element: (
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        ),
        children: [
          {
            path: "booking",
            element: <Booking />,
          },
          {
            path: "wishlist",
            element: <Wishlist />,
          },
          {
            path: "review",
            element: <Review />,
          },
          {
            path: "polls",
            element: <Polls />,
          },
          {
            path: "profile",
            element: <Profile />,
          },
          {
            path: "support",
            element: <Support />,
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Error />,
  },
]);

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <ToasterProvider>
            <RouterProvider router={appLayout} />
          </ToasterProvider>
        </GoogleOAuthProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
